import { callCreateSchedule } from "api/worker/schedule";
import { useModal } from "hooks/useModal";
import { robotKey } from "hooks/worker/keys";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { CleaningRobotItem } from "types/response/robot";
import { CreateScheduleRequest } from "types/schedule";
import { handleError } from "utils/error/handleError";

type UseCreateModalProps = {
  afterCallback?: () => void;
};

export const useCreateModal = ({ afterCallback }: UseCreateModalProps) => {
  const modal = useModal();
  const [isCreating, setIsCreating] = useState(false);
  const queryCleint = useQueryClient();

  const onCreate = async (input: CreateScheduleRequest) => {
    try {
      setIsCreating(true);

      const { scheduleId } = await callCreateSchedule(input);

      queryCleint.setQueryData<CleaningRobotItem[] | undefined>(
        robotKey.list(),
        (prev) => {
          if (!prev) return prev;
          return prev.map((robot) => {
            if (robot.robotId !== input.robotId) return robot;
            robot.schedules.push({
              scheduleId,
              ...input,
            });
            return robot;
          });
        }
      );

      modal.onClose();

      if (afterCallback) afterCallback();
    } catch (err) {
      handleError(err);
    } finally {
      setIsCreating(false);
    }
  };

  const onOpen = () => {
    modal.onOpen();
  };

  const onClose = () => {
    modal.onClose();
  };

  return {
    ...modal,
    onOpen,
    onClose,
    onCreate,
    isCreating,
  };
};
